// Example API response structure:
// {
//   success: boolean;
//   results: SavedSearch[];
//   total: number;
// }
const MOCK_SAVED_SEARCHES = [
  {
    id: "search-001",
    tipo: "Pesquisa",
    termo: "danos morais",
    filtros: {},
    createdAt: "2022-01-13T00:00:00.000Z",
  },
  {
    id: "search-002",
    tipo: "Pesquisa",
    termo: "leis trabalhistas",
    filtros: {},
    createdAt: "2022-01-13T00:00:00.000Z",
  },
  {
    id: "search-003",
    tipo: "Pesquisa",
    termo: "clt",
    filtros: {},
    createdAt: "2022-01-13T00:00:00.000Z",
  },
  {
    id: "search-004",
    tipo: "Pesquisa",
    termo: "trânsito",
    filtros: {},
    createdAt: "2022-01-13T00:00:00.000Z",
  },
  {
    id: "search-005",
    tipo: "Pesquisa",
    termo: "STF",
    filtros: {},
    createdAt: "2022-01-13T00:00:00.000Z",
  },
  {
    id: "search-006",
    tipo: "Pesquisa",
    termo: "TJSP",
    filtros: {},
    createdAt: "2022-01-13T00:00:00.000Z",
  },
];

interface Response {
  success: boolean;
  results: typeof MOCK_SAVED_SEARCHES;
  total: number;
}

export const getSavedSearches = async (): Promise<Response["results"]> => {
  // const response = await apiInstance.get<Response>("perfil/pesquisas");
  // return response.data.results;

  await new Promise((resolve) => setTimeout(resolve, 100));

  return MOCK_SAVED_SEARCHES;
};
